import React from 'react';

const HomeCar2 = props => {
  return (
    <div>
      {/* <iframe width="1440" height="720" src="https://lookerstudio.google.com/embed/reporting/a46b04d1-6cd1-48a7-83bb-fdfd026ac47c/page/sIgGD" 
        allowfullscreen>
      </iframe> */}
    </div>
  )
}

export default HomeCar2 